import { useCallback, useState } from 'react';
import { EMPTY_CUSTOMER_INTENT_SELECTION, normalizeCustomerIntentSelection } from '../constants';

/**
 * Open/close state for the "What should your model do next?" modal. Hosts
 * (Business Goals step, Edit Task modal) pass `openModal` down as the
 * `onContactUs` handler of the gated task-type / autonomy controls, which
 * call it with the `{features, autonomyLevels}` to pre-check (the task type or
 * autonomy level whose "Contact us" link was clicked). Hosts forward
 * `initialSelection` to `CustomerIntentModal`.
 */
export default function useCustomerIntentModal() {
    const [open, setOpen] = useState(false);
    const [initialSelection, setInitialSelection] = useState(EMPTY_CUSTOMER_INTENT_SELECTION);
    const openModal = useCallback((initial) => {
        setInitialSelection(normalizeCustomerIntentSelection(initial));
        setOpen(true);
    }, []);
    const closeModal = useCallback(() => setOpen(false), []);
    return { open, openModal, closeModal, initialSelection };
}
